<template>
  <fragment>
    <AppBody
      title="Eventos / Categorias"
      subtitle="Categorias"
      :actions="actions"
    >
      <v-form
        @submit.prevent="$produtos_categorias.filtroCategoria()"
        class="search-forms"
      >
        <v-row>
          <v-col cols="5">
            <label class="input-labels"> Descrição da categoria </label>
            <v-text-field
              solo
              placeholder="Insira a descrição"
              v-model="$produtos_categorias.filter.descricao"
              type="text"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="5">
            <label class="input-labels"> Status </label>
            <v-select
              height="48"
              :items="status_categorias"
              @click:clear="$produtos_categorias.filter.status = ''"
              clearable
              clear-icon="mdi-close-circle-outline"
              dense
              solo
              class="textinput"
              v-model="$produtos_categorias.filter.status"
              item-text="text"
              item-value="value"
              placeholder="Selecione o status"
            ></v-select>
          </v-col>
          <v-col cols="2" class="align-self-end ml-auto">
            <v-btn
              height="48"
              class="button btn-size btn-border"
              type="submit"
              :loading="$produtos_categorias.filtro_loading"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        no-data-text="Não há registro de categorias."
        loading-text="Buscando informações..."
        class="table-body"
        :loading="$produtos_categorias.cadastro.loading"
        :headers="headersCategorias"
        :items="tableValues"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Categorias por página:',
        }"
      >
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    openModal('modal-body-produtos-categorias', 'edit', item)
                  "
                  class="mr-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="
                    $produtos_categorias.remover(
                      item.idcategoria,
                      'Deseja realmente excluir esta categoria?'
                    )
                  "
                >
                  <v-icon> mdi-delete-outline </v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <ModalProdutosCategorias />
      <ModalConfirmacao
        :textModal="$produtos_categorias.text"
        @callback="$produtos_categorias.funcaoRemover"
      />
    </AppBody>
  </fragment>
</template>

<script>
export default {
  name: "Categories",
  metaInfo: {
    title: "Produtos/Categorias | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Produtos/Categorias | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    ModalProdutosCategorias: () =>
      import(
        "@/components/produtos/categorias/produtos-categorias-modal-add.vue"
      ),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Nova Categoria",
          action: () =>
            this.openModal("modal-body-produtos-categorias", "new", ""),
        },
      ],
      headersCategorias: [
        {
          text: "Ordem",
          align: "center",
          sortable: true,
          value: "ordem",
        },
        {
          text: "Descrição",
          align: "center",
          sortable: true,
          value: "descricao_pt_br",
        },
        {
          text: "Data do cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "ativo",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      status_categorias: [
        {
          text: "ATIVO",
          value: 1,
        },
        {
          text: "INATIVO",
          value: 0,
        },
      ],
    };
  },
  computed: {
    tableValues() {
      this.$produtos_categorias.categorias.forEach(item => {
        item.ativo = item.ativo == 1 ? "ATIVO" : "INATIVO";
        item.descricao;
        item.descricao_pt_br = this.$config.convertTagString(item.descricao);
        item.ins_dthr = this.$config.convertDataBR(
          item.ins_dthr.substring(0, 10)
        );
      });

      return this.$produtos_categorias.categorias;
    },
  },
  methods: {
    openModal(name, type, data) {
      this.$produtos_categorias.categoriasAddEdit = type;
      if (data) {
        this.$produtos_categorias.cadastro.idcategoria = data.idcategoria;
        if (data.is_marketplace) {
          this.$produtos_categorias.cadastro.isHomeMkt = data.is_marketplace;
        }
        if (data.is_two_rows) {
          this.$produtos_categorias.cadastro.isTwoRows = data.is_two_rows;
        }
        if (data.descricao) {
          this.$produtos_categorias.cadastro.descricao_pt_br =
            data.descricao.substring(
              data.descricao.indexOf("<pt_BR>") + 7,
              data.descricao.indexOf("</pt_BR>")
            );
          this.$produtos_categorias.cadastro.descricao_en_us =
            data.descricao.substring(
              data.descricao.indexOf("<en_US>") + 7,
              data.descricao.indexOf("</en_US>")
            );
          this.$produtos_categorias.cadastro.descricao_es_es =
            data.descricao.substring(
              data.descricao.indexOf("<es_ES>") + 7,
              data.descricao.indexOf("</es_ES>")
            );
        }
        if (data.descritivo) {
          this.$produtos_categorias.cadastro.descritivo_pt_br =
            data.descritivo.substring(
              data.descritivo.indexOf("<pt_BR>") + 7,
              data.descritivo.indexOf("</pt_BR>")
            );
          this.$produtos_categorias.cadastro.descritivo_en_us =
            data.descritivo.substring(
              data.descritivo.indexOf("<en_US>") + 7,
              data.descritivo.indexOf("</en_US>")
            );
          this.$produtos_categorias.cadastro.descritivo_es_es =
            data.descritivo.substring(
              data.descritivo.indexOf("<es_ES>") + 7,
              data.descritivo.indexOf("</es_ES>")
            );
        }
        this.$produtos_categorias.cadastro.status =
          data.ativo === "ATIVO" ? 1 : 0;
        this.$produtos_categorias.cadastro.ordem = data.ordem;
        if (data.icone) {
          this.$produtos_categorias.cadastro.icone.imagem = data.icone;
          this.$produtos_categorias.cadastro.icone.have = true;
        }
        if (data.banner) {
          if (data.banner) {
            this.$produtos_categorias.cadastro.banner.imagem = data.banner;
            this.$produtos_categorias.cadastro.banner.have = true;
          }
        }
        // this.$produtos_categorias.cadastro.descritivo = data.descritivo
      }
      document.getElementsByClassName(name)[0].style.display = "flex";
    },
  },
  mounted() {
    this.$produtos_categorias.getCategorias();
  },
  destroyed() {
    this.$produtos_categorias.limpaFormularioDeCategoriaProduto();
    this.$produtos_categorias.limpaFiltros();
  },
};
</script>

<style scoped>
.produtos-categorias-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-categorias-icon {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}

.produtos-categorias-icon2 {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
</style>
